const AffiliateService = {
  getAffiliateBranding: (affiliateRef) => {
    return { ...window.branding['DEFAULT'], ...window.branding[affiliateRef.toLowerCase()] };
  },
  getBrandingByRefId: (refId) => {
    let brand = Object.values(window.branding).find(x => x.affiliateId == refId.toLowerCase());
    return { ...window.branding['DEFAULT'], ...brand };
  }
}

export default AffiliateService;
